import { RestrictedSidebar } from "@/components/sidebar/RestrictedSidebar.tsx";
import { useAppRoutes } from "@/routes/use-routes.hook.ts";
import { SidebarLayout } from "@skailer-com/uikit";
import { Navigate, Outlet, matchPath, useLocation } from "react-router-dom";

const ALLOWED_PATTERNS = [
  "/preboarding",
  "/surveys/:id/respond/:step?",
  "/esign/requests/:requestId",
];

export default function RestrictedPortalLayout() {
  const location = useLocation();
  const { isFullScreenRoute } = useAppRoutes();

  const isAllowed = ALLOWED_PATTERNS.some((pattern) => matchPath(pattern, location.pathname));

  if (!isAllowed) {
    return <Navigate to="/preboarding" replace />;
  }

  const isRailHidden = isFullScreenRoute && !matchPath("/preboarding", location.pathname);

  return (
    <div className="flex h-full w-full print:block">
      {/* Колонку меряет лейаут кита — тот же источник ширины, что и в AppLayout.
          Панели второго уровня у портала нет: навигация здесь плоская. */}
      {!isRailHidden && (
        <SidebarLayout className="shrink-0 print:hidden" rail={<RestrictedSidebar />} />
      )}
      <main className="flex-1 min-w-0 h-full overflow-y-auto print:h-auto print:overflow-visible print:block">
        <Outlet />
      </main>
    </div>
  );
}
